"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUserApiClient = createUserApiClient;
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function createUserApiClient(apiHost, options) {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function sendInvite(params) {
        try {
            await client.post('/v1/invite', params.request);
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function registerUser(params) {
        try {
            const response = await client.post('/v2/users', params.newUser);
            const location = response.headers?.location || '';
            const matches = location.match(/\/v2\/users\/([0-9]*)/) || [];
            if (matches.length > 0) {
                const userId = matches[1];
                return userId && +userId || undefined;
            }
            return undefined;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function fetchUsersByPartnerIdAndMembershipNumber(partnerId, membershipNumber, onlyConfirmedProfiles = true) {
        try {
            const params = { all_profiles: !onlyConfirmedProfiles };
            const response = await client.get(`/v1/partners/${partnerId}/memberships/${membershipNumber}/users`, { params });
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function createUser(email, hasAcceptedFarmerCgu) {
        try {
            const response = await client.post('/v1/users', {
                email,
                has_accepted_farmer_cgu: hasAcceptedFarmerCgu
            });
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function createConfirmedProfile(userId, membershipNumber, partnerId, origin) {
        try {
            const response = await client.post('/v1/confirmed-profiles', {
                user_id: userId,
                membership_number: membershipNumber,
                partner_id: partnerId,
                origin: origin
            });
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function validateProfileAssociation(request) {
        try {
            const response = await client.post('/v1/profiles/validate-association', request);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function refuseProfileAssociation(request) {
        try {
            const response = await client.post('/v1/profiles/refuse-association', request);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function setCurrentCustomer(request) {
        try {
            await client.post('/v1/users/me/currentCustomer', request);
            return;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function checkUserPermissions(userId, permissions) {
        try {
            const params = { permissions: permissions.join(',') };
            const response = await client.get(`/v1/users/${userId}/permissions/check`, { params });
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function assignRoleToUser(userId, payload) {
        try {
            await client.post(`/v1/users/${userId}/roles`, payload);
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function exportUsersByType(type) {
        try {
            const response = await client.get('/v2/users/export', { params: { type } });
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    return {
        sendInvite,
        registerUser,
        fetchUsersByPartnerIdAndMembershipNumber,
        createUser,
        createConfirmedProfile,
        validateProfileAssociation,
        refuseProfileAssociation,
        setCurrentCustomer,
        checkUserPermissions,
        assignRoleToUser,
        exportUsersByType
    };
}
